import React, { useState, useEffect } from "react";
import { Box, Card, Grid, Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router";
import CustomStepper from "../../../Components/Stepper";
import MuiButton from "../../../Components/MuiButton";
import ChooseDoctor from "../steps/choose-doctor";
import AppointmentInfo from "../steps/appointment-info";
import PaymentDetails from "../steps/payment-details";
import { toast } from "react-toastify";
import PickTime from "../steps/pick-time";
import { API_URL } from "../../../configs/endpoint";
export default function RightSection() {
  // const API_ENDPOINT = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const doctorId = searchParams.get("doctorId"); // 👈 get query param
  const patientId = searchParams.get("patientId"); // 👈 get query param
  const { control, handleSubmit, reset, watch, setValue } = useForm();
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const steps = [
    "Choose a Doctor",
    "Pick a Time",
    "Appointment Info",
    "Payment Details",
  ];

  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const stepForms = [
    <ChooseDoctor control={control} handleNext={handleNext} />,
    <PickTime
      control={control}
      watch={watch}
      setValue={setValue}
      handleNext={handleNext}
    />,
    <AppointmentInfo control={control} />,
    <PaymentDetails control={control} />,
  ];
  // console.log("watch = ", watch());
  const onSubmit = async (data) => {
    // console.log("data = ", data);
    if (activeStep === steps?.length - 1) {
      // if (data?.patient) {
      //   delete data?.patient;
      // }

      setLoading(true);
      // console.log("api calling");
      const formData = new FormData();

      // append normal fields
      for (let key in data) {
        if (key !== "attachments" && key !== "paymentReceipt") {
          formData.append(key, data[key]);
        }
      }

      // append attachments (multiple files)
      if (data?.attachments && data.attachments.length > 0) {
        for (let i = 0; i < data.attachments.length; i++) {
          formData.append("attachments", data.attachments[i]);
        }
      }

      // append paymentReceipt (multiple files)
      if (data?.paymentReceipt && data.paymentReceipt.length > 0) {
        for (let i = 0; i < data.paymentReceipt.length; i++) {
          formData.append("paymentReceipt", data.paymentReceipt[i]);
        }
      }
      // console.log("form data = ", formData);
      axios
        .post(`${API_URL}/appointment`, formData)
        .then((response) => {
          navigate("/successful-submission");
        })
        .catch((error) => {
          // console.log("error = ", error);
          // show the server's reason when it sends one (e.g. the daily booking limit)
          toast.error(error?.response?.data?.error || "Something went wrong!");
        })
        .finally(() => {
          setLoading(false);
        });
    } else if (activeStep === 0 && data?.doctor === undefined) {
      toast.info("Please select a doctor to continue");
    } else if (activeStep === 1 && !data?.startTime) {
      // console.log("data = ", data);
      toast.info("Please select a time slot to continue");
    } else {
      handleNext();
    }
  };
  useEffect(() => {
    if (doctorId) {
      // console.log("doctorid = ", doctorId);
      // 👇 set doctor ID into the form state
      setValue("doctor", doctorId);
      // 👇 skip to step 2
      setActiveStep(1);
    }
    if (patientId) {
      setValue("patient", patientId);
      // 👇 skip to step 2
      setActiveStep(1);
    }
  }, [doctorId, patientId, setValue]);

  return (
    <Grid
      item
      xs={12}
      md={9}
      sx={{
        padding: { xs: "16px", md: 4 },
        // bgcolor: "yellow",
        display: "flex",
        flexDirection: "column",
        justifyContent: { xs: "start", md: "center" },
      }}
      component="form"
      onSubmit={handleSubmit(onSubmit)}
    >
      <CustomStepper steps={steps} activeStep={activeStep} />
      <Card
        sx={{
          my: 4,
          padding: { xs: 2, md: 4 },
          height: { xs: "100%", md: "400px" }, // Minimum height for consistency
          // maxHeight: "500px", // Minimum height for consistency
          overflow: "auto",
        }}
      >
        {stepForms[activeStep]}
      </Card>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <MuiButton onClick={handleBack} disabled={loading || activeStep === 0}>
          Back
        </MuiButton>
        <Stack direction="row" alignItems="center" gap={2}>
          {/* {activeStep === steps.length - 1 && (
            <ReCAPTCHA sitekey={RECAPTCHA_SITE_KEY} onChange={() => {}} />
          )} */}
          <MuiButton type="submit" loading={loading}>
            {activeStep === steps.length - 1 ? "Finish" : "Next"}
          </MuiButton>
        </Stack>
      </Box>
    </Grid>
  );
}
